import {colors} from 'shells/colors/colors';

import type {EntityType} from 'nutshell-graphql-types';

import type {FormFieldRowForDuplicateHelpers} from '../../../types';

export const getIconColor = (entityType: EntityType) => {
    switch (entityType) {
        case 'ACCOUNT':
            return colors.company;
        case 'LEAD':
            return colors.lead;
        case 'CONTACT':
        default:
            return colors.person;
    }
};

export const getNameOptionIsDisabled = (
    fields: FormFieldRowForDuplicateHelpers[],
    value: string
): boolean => {
    const fieldNamesToDisable = [value];
    if (value === 'firstName' || value === 'lastName') {
        fieldNamesToDisable.push('name');
    }

    if (value === 'name') {
        fieldNamesToDisable.push('firstName', 'lastName');
    }

    return Boolean(
        fieldNamesToDisable.find((nameToDisable) =>
            fields.find(
                (field) =>
                    field.type === 'INPUT' &&
                    field.entityType === 'CONTACT' &&
                    field.fieldName &&
                    nameToDisable === field.fieldName
            )
        )
    );
};
